export default __webpack_public_path__ + "../staticImages/bg-sand-dark.webp";